import React from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import BannerHerro from '../components/BannerHero'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import category1 from './../assets/category/1.png'
import category2 from './../assets/category/2.png'
import category3 from './../assets/category/3.png'
import category4 from './../assets/category/4.png'
import category5 from './../assets/category/telco.png'
import category6 from './../assets/category/cyber-icon.png'

import exp from './../assets/exp.png'
import arrow from './../assets/arrow-right.png'
import obi from './../assets/obi.png'
import download from './../assets/download.png'

import solution1 from './../assets/solution/1.png'
import solution2 from './../assets/solution/2.png'
import solution3 from './../assets/solution/3.png'
import solution4 from './../assets/solution/4.png'
import solution5 from './../assets/solution/5.png'
import solution11 from './../assets/solution/11.png'

import image1 from './../assets/partner/Neural.png'
import image2 from './../assets/partner/Liferay.png'
import image3 from './../assets/partner/Orca.png'
import image4 from './../assets/partner/Telin.png'
import image5 from './../assets/partner/Myson.png'
import image6 from './../assets/partner/logo-orca.png'
import image7 from './../assets/partner/logo-sobot.png'

import client1 from './../assets/client/1.png'
import client2 from './../assets/client/2.png'
import client3 from './../assets/client/3.png'
import client4 from './../assets/client/4.png'
import client5 from './../assets/client/5.png'
import client6 from './../assets/client/6.png'
import client7 from './../assets/client/7.png'
import client8 from './../assets/client/8.png'
import client9 from './../assets/client/9.png'
import client10 from './../assets/client/10.png'
import client11 from './../assets/client/11.png'
import client12 from './../assets/client/12.png'
import client13 from './../assets/client/13.png'
import client14 from './../assets/client/14.png'
import client15 from './../assets/client/15.png'
import client16 from './../assets/client/16.png'
import client17 from './../assets/client/17.png'
import client18 from './../assets/client/18.png'

import c27001 from './../assets/27001.png'
import c9001 from './../assets/9001.png'
import noname from './../assets/solution/noname.png'
import proofpoint from './../assets/solution/proofpoint.png'
import ecouncil from './../assets/solution/ecouncil2.png'
import djarum from './../assets/use-cases/djarum.jpg'

import { AnimationOnScroll } from 'react-animation-on-scroll';
import { useNavigate } from 'react-router-dom';

import CarouselBanner from '../components/CarouselBanner';
import OurSolution from '../components/OurSollution';
import img01 from './../assets/img01.png'
import Agile from '../components/Agile';
import Client from '../components/Client';
import OurTechnology from '../components/OurTechnology';
import Discover from '../components/Discover';

const settings = {
  dots: true,
  autoplay: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplaySpeed: 3000,
  speed: 1000,
  arrows: false
}

const business = [
  {
    icon: category6,
    title: "Cyber Security",
    short_desc: "It is an ongoing process that demands constant vigilance, investment, and collaboration to mitigate the risks associated with an ever-evolving digital landscape."
  },
  {
    icon: category1,
    title: "Advertising & Customer Engagement",
    short_desc: "We make your brand relatable and meaningful through our customer engagement & advertising platform."
  },
  {
    icon: category2,
    title: "Outsourcing & Talent Management",
    short_desc: "Providing professional manpower services for sales promotion and marketing purposes using technology."
  },
  {
    icon: category3,
    title: "e-Commerce",
    short_desc: "Building solution to enhance your e-commerce results from acquisition, performance data, to retention."
  },
  {
    icon: category4,
    title: "Tenant Management System",
    short_desc: "Helps real estate professionals using technology to manage and serve their tenants, including rental property owners, landlords, and property managers."
  },
  {
    icon: category5,
    title: "Telco Solutions",
    short_desc: "Providing high quality project management, systems integration, system design and network implementation services."
  }
]

const Home = () => {
  const navigate = useNavigate();


  return (
    <div className='wrap-hidden'>
      <div className='bg-header relative'>
        <div className='box-dot' />
      </div>
      <Container className='mt-5'>
        <CarouselBanner />
      </Container>
      <Container className='mt-5'>
        <OurSolution />
      </Container>
      <Container className='mt-5'>
        <Agile />
      </Container>

      <Container className='mt-5'>
        <Client />
      </Container>

      <Container className='mt-5'>
        <OurTechnology />
      </Container>

      <Container className='mt-5 mb-5'>
        <Discover />
      </Container>

    </div>
  )
}

export default Home